.upsideDown {
  transform: rotate(180deg);
}

.cardImage {
  /* sharpen images up in safari/chrome, otherwise they are a bit blurry */
  image-rendering: -webkit-optimize-contrast;
  /* some scroll issues in chrome on storybook
  unclear if this really helped a lot...
  https://stackoverflow.com/questions/34824098/why-is-svg-scrolling-performance-so-much-worse-than-png
  */
  buffered-rendering: static;

  &.roundedCorners {
    border-radius: 4px;
  }
}
